import React, { Component } from 'react';
import PanelLink from "../../widgets/PanelLink";
import { observer } from 'mobx-react';

import queryString from "query-string";

const UncertifedPanelLink = function (props) {
    let timesheets = props.store.timesheets.collection.filter(timesheet => timesheet.isFinal);

    let timesheetNumber = timesheets.length;

    //Get count of uncertified timesheets
    let uncertifiedNumber = timesheets.reduce(
        (acc, currentTimesheet) => currentTimesheet.isCertified ? acc : acc + 1 ,
        0
    );


    return (
        <PanelLink path={`/staff/certifyTimesheets`}>
            <div>
                <span className="panelLinkLarge">{uncertifiedNumber}</span>
                <span className="panelLinkSmall">/{timesheetNumber}</span>
            </div>
            <span>
                Uncertified
            </span>
            <span>
                Timesheets
            </span>
        </PanelLink>
    )
}

export default observer(UncertifedPanelLink);